import { render, staticRenderFns } from "./UHF-PS1.vue?vue&type=template&id=4b7848ea&scoped=true&lang=pug"
import script from "./UHF-PS1.vue?vue&type=script&lang=js"
export * from "./UHF-PS1.vue?vue&type=script&lang=js"
import style0 from "./UHF-PS1.vue?vue&type=style&index=0&id=4b7848ea&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7848ea",
  null
  
)

export default component.exports